

export enum GROWL_TYPE {
    CLIENT  = "client",
    ACCOUNT = "account",
    CONTACT = "contact",
}
